import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// helpers
import { formatTime } from 'lib/helpers/time'

const WaiverAccepted = props => {
  const { acceptedBy, createdAt } = props

  return (
    <Box align='center'>
      <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
        Accepted by {acceptedBy} on {formatTime(createdAt)}
      </Typography>
    </Box>
  )
}

export default WaiverAccepted
